import axios from "axios";
import axiosRetry from "axios-retry";

import { API_BASE_URL } from "@/config";

const RETRY_DELAY_INCREMENT_MS = 1000;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});


axiosRetry(api, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * RETRY_DELAY_INCREMENT_MS;
  },
 retryCondition: (error) => {
    return (
      error.code === "ECONNABORTED" ||
      axiosRetry.isIdempotentRequestError(error)  
    );
  },
});

export default api;
